import { createFileRoute } from '@tanstack/react-router';
import { ListagemCliente } from '@/features/cliente/page/listagem/ListagemCliente';

export const Route = createFileRoute('/a/cliente/')({
    component: ListagemCliente,
});
